/* The Festive Atelier — Halloween FX
 * Decorative only: embers, bats, ghosts, spiders, cobwebs, rolling pumpkins.
 * Layers are aria-hidden and pointer-events:none, so nothing blocks clicks.
 * Level comes from window.TFA_FX.level ('light' | 'normal' | 'dense' | 'off'),
 * set in snippets/tfa-halloween-fx.liquid. Skipped entirely for reduced-motion users.
 */
(function () {
  'use strict';
  if (window.__tfaFx) return;
  window.__tfaFx = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce && reduce.matches) return;

  var cfg = window.TFA_FX || {};
  var level = cfg.level || 'normal';
  if (level === 'off') return;

  document.documentElement.classList.add('tfa-on');

  var small = window.innerWidth < 750;
  var mult = level === 'dense' ? 1.6 : level === 'light' ? 0.5 : 1;
  if (small) mult *= 0.55;
  function n(x) { return Math.max(0, Math.round(x * mult)); }
  function r(a, b) { return a + Math.random() * (b - a); }
  function f(x) { return x.toFixed(2); }

  var BAT_PATH = 'M24 8c-1-2-2.6-3.4-4-3.6.6 1.4.4 3-.6 4.2C15.6 5.8 9 5.4 1 9.6c4.4.6 6.8 3 7.4 6.6 2.4-1.8 5.4-1.8 7.4.2 1.6-1.6 4-2 5.8-.6L24 20l2.4-4.2c1.8-1.4 4.2-1 5.8.6 2-2 5-2 7.4-.2.6-3.6 3-6 7.4-6.6-8-4.2-14.6-3.8-18.4-1-1-1.2-1.2-2.8-.6-4.2C26.6 4.6 25 6 24 8z';
  var WEB_PATH = 'M0 0L170 0M0 0L162 53M0 0L138 100M0 0L100 138M0 0L53 162M0 0L0 170M34 0Q29 5 32 11Q26 13 28 20Q20 20 20 28Q13 26 11 32Q5 29 0 34M66 0Q55 9 63 20Q50 25 53 39Q40 40 39 53Q25 50 20 63Q9 55 0 66M100 0Q84 13 95 31Q76 39 81 59Q60 60 59 81Q39 76 31 95Q13 84 0 100M138 0Q116 18 131 43Q104 53 112 81Q83 83 81 112Q53 104 43 131Q18 116 0 138';
  var GHOST_SVG = '<svg viewBox="0 0 40 48"><path d="M20 2C10.6 2 4 9.6 4 19.5V45l5.4-4.4L14.7 45 20 40.6 25.3 45l5.3-4.4L36 45V19.5C36 9.6 29.4 2 20 2z" fill="#F4ECDF" fill-opacity=".92"/><ellipse cx="14.5" cy="19" rx="2.4" ry="3.4" fill="#141016"/><ellipse cx="25.5" cy="19" rx="2.4" ry="3.4" fill="#141016"/><ellipse cx="20" cy="27.5" rx="2.2" ry="2.8" fill="#141016"/></svg>';
  var SPIDER_SVG = '<svg viewBox="0 0 32 32" fill="none" stroke="#CFC3B3" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="12,15 6,10 4,5"/><polyline points="11.5,18 4,16 1.5,20"/><polyline points="12,20.5 6,24 4,29"/><polyline points="13.5,22.5 10,28 9.5,31"/><polyline points="20,15 26,10 28,5"/><polyline points="20.5,18 28,16 30.5,20"/><polyline points="20,20.5 26,24 28,29"/><polyline points="18.5,22.5 22,28 22.5,31"/><circle cx="16" cy="11" r="3.2" fill="#0B080D"/><circle cx="16" cy="19" r="5.4" fill="#0B080D"/><circle cx="14.7" cy="10.6" r=".9" fill="#F08A2B" stroke="none"/><circle cx="17.3" cy="10.6" r=".9" fill="#F08A2B" stroke="none"/></svg>';
  var PUMPKIN_SVG = '<svg viewBox="0 0 56 56"><path d="M28 12c0-4 1.5-7 5-8.5" fill="none" stroke="#6B4E2A" stroke-width="3.5" stroke-linecap="round"/><ellipse cx="18" cy="33" rx="13" ry="18" fill="#C9621A"/><ellipse cx="38" cy="33" rx="13" ry="18" fill="#C9621A"/><ellipse cx="28" cy="33" rx="12" ry="19.5" fill="#F08A2B"/><path d="M17 29l5-7 4.5 7z" fill="#FFD27A"/><path d="M29.5 29l4.5-7 5 7z" fill="#FFD27A"/><path d="M16 37q12 9 24 0l-3 5.5-3-3.5-3 4.5-3-4.5-3 4.5-3-3.5z" fill="#FFD27A"/></svg>';

  /* ---------- element builders (static strings only) ---------- */
  function embers(k) {
    var h = '';
    for (var i = 0; i < k; i++) {
      var s = Math.round(r(4, 7.5));
      h += '<span class="tfa-ember" style="left:' + f(r(1, 99)) + '%;width:' + s + 'px;height:' + s + 'px;animation-delay:-' + f(r(0, 12)) + 's;animation-duration:' + f(r(8, 13)) + 's"></span>';
    }
    return h;
  }
  function stars(k, maxTop) {
    var h = '';
    for (var i = 0; i < k; i++) {
      h += '<span class="tfa-star" style="left:' + f(r(1, 99)) + '%;top:' + f(r(2, maxTop || 40)) + '%;animation-delay:-' + f(r(0, 3.4)) + 's;animation-duration:' + f(r(2.6, 4.6)) + 's"></span>';
    }
    return h;
  }
  function bats(k, color, top0, top1) {
    var h = '';
    for (var i = 0; i < k; i++) {
      var w = Math.round(r(24, small ? 34 : 44));
      h += '<span class="tfa-bat" style="top:' + f(r(top0 || 4, top1 || 50)) + '%;width:' + w + 'px;animation-delay:-' + f(r(0, 18)) + 's;animation-duration:' + f(r(12, 20)) + 's"><svg viewBox="0 0 48 24"><path d="' + BAT_PATH + '" fill="' + (color || '#0B080D') + '"/></svg></span>';
    }
    return h;
  }
  function ghost(left, top, size) {
    return '<span class="tfa-ghost" style="left:' + left + '%;top:' + top + '%;width:' + Math.round(size * (small ? 0.75 : 1)) + 'px;animation-delay:-' + f(r(0, 5)) + 's;animation-duration:' + f(r(5, 7)) + 's">' + GHOST_SVG + '</span>';
  }
  function spider(left, thread) {
    if (small) return '';
    return '<span class="tfa-spider" style="left:' + left + '%;animation-delay:-' + f(r(0, 7)) + 's"><i style="height:' + thread + 'px"></i>' + SPIDER_SVG + '</span>';
  }
  function webs(which, size, stroke) {
    var s = Math.round(size * (small ? 0.65 : 1));
    var c = stroke || '#F4ECDF';
    var h = '';
    if (which.indexOf('l') >= 0) h += '<svg class="tfa-web tfa-web--l" style="width:' + s + 'px;height:' + s + 'px" viewBox="0 0 170 170" fill="none" stroke="' + c + '" stroke-opacity=".32" stroke-width="1.1"><path d="' + WEB_PATH + '"/></svg>';
    if (which.indexOf('r') >= 0) h += '<svg class="tfa-web tfa-web--r" style="width:' + s + 'px;height:' + s + 'px" viewBox="0 0 170 170" fill="none" stroke="' + c + '" stroke-opacity=".32" stroke-width="1.1"><path transform="translate(170 0) scale(-1 1)" d="' + WEB_PATH + '"/></svg>';
    return h;
  }
  function pumpkins(k, bottom, size) {
    var h = '';
    var sz = Math.round(size * (small ? 0.7 : 1));
    for (var i = 0; i < k; i++) {
      var d = f(i * 9 + r(0, 4));
      h += '<span class="tfa-roll" data-size="' + sz + '" style="bottom:' + bottom + 'px;width:' + sz + 'px;animation-delay:-' + d + 's"><span style="animation-delay:-' + d + 's">' + PUMPKIN_SVG + '</span></span>';
    }
    return h;
  }
  function moon(left, top, size) {
    var s = Math.round(size * (small ? 0.6 : 1));
    return '<span class="tfa-moon" style="left:' + left + '%;top:' + top + 'px;width:' + s + 'px;height:' + s + 'px"></span>';
  }
  function fog() {
    return '<span class="tfa-fog" style="left:-10%;width:65%"></span><span class="tfa-fog" style="left:45%;width:70%;animation-duration:22s;animation-delay:-8s"></span>';
  }

  /* ---------- hosts ---------- */
  var hosts = [];
  function mount(el, front, back) {
    if (!el || el.__tfa) return;
    el.__tfa = true;
    var cs = window.getComputedStyle(el);
    el.classList.add('tfa-host');
    if (cs.position === 'static') el.classList.add('tfa-host--pos');
    if (cs.overflow === 'visible' || cs.overflowX === 'visible') el.classList.add('tfa-host--clip');
    var layers = [];
    if (back) {
      el.classList.add('tfa-host--lift');
      var b = document.createElement('div');
      b.className = 'tfa-fx tfa-fx--back';
      b.setAttribute('aria-hidden', 'true');
      b.innerHTML = back;
      el.insertBefore(b, el.firstChild);
      layers.push(b);
    }
    if (front) {
      var fr = document.createElement('div');
      fr.className = 'tfa-fx';
      fr.setAttribute('aria-hidden', 'true');
      fr.innerHTML = front;
      el.appendChild(fr);
      layers.push(fr);
    }
    hosts.push({ el: el, layers: layers });
  }
  function measure(hst) {
    var w = hst.el.offsetWidth, h = hst.el.offsetHeight;
    hst.layers.forEach(function (l) {
      l.style.setProperty('--tfa-w', w + 'px');
      l.style.setProperty('--tfa-h', h + 'px');
      var rolls = l.querySelectorAll('.tfa-roll');
      for (var i = 0; i < rolls.length; i++) {
        var sz = parseFloat(rolls[i].getAttribute('data-size')) || 48;
        var turns = (w + 160) / (Math.PI * sz);
        rolls[i].style.setProperty('--tfa-spin', Math.round(turns * 360) + 'deg');
      }
    });
  }
  function q(sel) { return document.querySelector(sel); }
  function sectionOf(sel) { var e = q(sel); return e ? e.closest('section') : null; }

  function build() {
    var dense = level === 'dense';

    /* Home */
    mount(q('.fa-hero'),
      embers(n(16)) + bats(n(3), null, 4, 45) + ghost(74, 3, 56) + spider(47, 170) + webs('lr', 170) + pumpkins(dense ? 2 : 1, 4, 52),
      moon(70, -170, 560) + stars(n(12), 60) + fog());
    mount(sectionOf('.fa-vibes__grid'),
      embers(n(8)) + bats(n(2), null, 4, 70) + spider(78, 110));
    mount(q('#bestsellers'),
      embers(n(7)) + bats(n(1), null, 3, 20) + ghost(32, 4, 44) + pumpkins(1, 24, 44));
    mount(q('.fa-bundle'), bats(Math.max(1, n(3)), '#1A1208', 5, 90));
    mount(q('.fa-story'), bats(Math.max(1, n(2)), '#141016', 4, 90) + webs('r', 180, '#141016'));
    mount(q('.fa-news'), embers(n(5)) + ghost(92, 6, 40));
    mount(q('.fa-footer'), stars(n(4), 60) + embers(n(4)) + bats(n(1), null, 10, 40));

    /* Product */
    mount(q('.fa-pdp'),
      embers(n(10)) + stars(n(5), 90) + bats(n(3), null, 2, 80) + spider(50, 200) + ghost(97, 1, 40) + ghost(0.5, 45, 36));
    mount(q('.fa-gallery__main'), embers(n(7)));
    mount(q('.fa-features'), bats(Math.max(1, n(2)), '#141016', 5, 85));
    if (q('.fa-pdp')) {
      var related = null;
      document.querySelectorAll('section.fa-section').forEach(function (s) {
        if (!related && s.querySelector('.fa-grid') && !s.closest('.fa-pdp')) related = s;
      });
      mount(related, webs('lr', 160) + bats(n(2), null, 3, 30) + ghost(38, 5, 44) + pumpkins(dense ? 2 : 1, 20, 48));
    }

    /* Collection */
    mount(q('.fa-coll__head'),
      embers(n(7)) + bats(n(2), null, 5, 50) + ghost(82, 8, 48) + webs('lr', 140) + pumpkins(1, 2, 40),
      moon(78, -260, 520) + stars(n(4), 60));

    hosts.forEach(measure);
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function (entries) {
        entries.forEach(function (en) {
          for (var i = 0; i < hosts.length; i++) if (hosts[i].el === en.target) measure(hosts[i]);
        });
      });
      hosts.forEach(function (h) { ro.observe(h.el); });
    } else {
      window.addEventListener('resize', function () { hosts.forEach(measure); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  else build();
})();
